import { createContext } from "react"

export interface SignupFormData {
    nric?: string,
    name?: string,
    cardName?: string,
    dateOfBirth?: Date,
    gender?: string,
    mobileNumber?: string,
    email?: string,
    residentialStatus?: string,
    race?: string,
    maritalStatus?: string,
    educationStatus?: string,
    address?: string,
    jobTitle?: string,
    occupation?: string,
    company?: string,
    salary?: string,
    bankName?: string,
    accountNumber?: string,
}

const defaultFormData: SignupFormData = {}

export const SignupFormContext = createContext<SignupFormData>(defaultFormData)
